import { ApplicationState } from '@store/store';

export const merchantNameSelector = (store: ApplicationState) => store.merchantInfo.merchantInfo?.merchantName;

export const merchantInfoStatus = (store: ApplicationState) => store.merchantInfo.status;
